import { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { showCashout } from 'right-sidebar';

const Cashout = () => {
  useEffect(() => {
    showCashout();
  }, []);

  return <Redirect to="/" />;
};

export default Cashout;
